import { Layout } from "antd";
import React from "react";
import { Headbar } from "../headbar/Headbar";
import { Sidebar } from "../sidebar/Sidebar";

const PrivateComponent = ({ component, portal }) => {
  return (
    <>
      {portal ? (
        <Layout style={{ minHeight: "100vh" }}>
          <Headbar />
          <Layout style={{ paddingLeft: "210px", paddingRight: "430px" }}>
            {component}
          </Layout>
        </Layout>
      ) : (
        <Layout style={{ height: "auto", minHeight: "100vh" }}>
          <Headbar />
          <Layout>
            <Sidebar />
            <Layout.Content className="px-10 py-5">{component}</Layout.Content>
          </Layout>
        </Layout>
      )}
    </>
  );
};

export default PrivateComponent;
